export default __webpack_public_path__ + "static/media/default-banner.87685114.jpg";